import { StandardDonationAasmState } from '@types'
import 'mapbox-gl/dist/mapbox-gl.css'
import { useRef } from 'react'
import { useMapInstance, useMapMarkers, useUserLocation } from './hooks'
import styles from './Map.module.scss'

export interface MapMarker {
  id: number
  stepNumber: number
  status: 'dispatch' | 'return' | StandardDonationAasmState
  lat: number
  lng: number
}

interface MapProps {
  markers: MapMarker[]
  accessToken: string
  showZoomControls?: boolean
  interactive?: boolean
  showUserLocation?: boolean
  showMarkerBadges?: boolean
}

export const Map = ({
  markers,
  accessToken,
  showZoomControls = true,
  interactive = true,
  showUserLocation = true,
  showMarkerBadges = true,
}: MapProps) => {
  const containerRef = useRef<HTMLDivElement>(null)

  const userLocation = useUserLocation(showUserLocation)

  const { mapRef, isReady } = useMapInstance({
    accessToken,
    containerRef,
    interactive,
  })

  useMapMarkers({
    mapRef,
    isMapReady: isReady,
    markers,
    userLocation,
    showUserLocation,
    showMarkerBadges,
  })

  const handleZoomIn = () => {
    mapRef.current?.zoomIn()
  }

  const handleZoomOut = () => {
    mapRef.current?.zoomOut()
  }

  return (
    <div className={styles.container}>
      <div ref={containerRef} className={styles.map} />
      {showZoomControls && (
        <div className={styles.zoomControls}>
          <button className={styles.zoomButton} onClick={handleZoomIn}>
            +
          </button>
          <button className={styles.zoomButton} onClick={handleZoomOut}>
            −
          </button>
        </div>
      )}
    </div>
  )
}
